import React from 'react'
import { MFAInputCode } from '../../components'
import { AuthPage } from './AuthPage'

const MultiFactorLoginPage = () => {
  return (
    <AuthPage
      headerSubtitle={<p className='d-flex w-100 justify-content-center align-items-baseline'>Two-factor authentication</p>}
      form={<MFAInputCode />}
    />
  )
}

export default MultiFactorLoginPage
